import ApiService from '@/common/api.service'

const RESOURCE = 'genres'
const GenreService = {
  actors (type, id, params) {
    return ApiService.query(`${RESOURCE}/${type}/${id}/actors`, params)
  }
}
export default GenreService
